import React, { useState, useContext, useRef } from 'react';
import { useTranslation } from "react-i18next";
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { AuthContext } from '../../../../Header/auth - context';
import './PromenaLozinke.css';

const emptyForm = { currentPassword: '', newPassword: '', confirmPassword: '' };

const PromenaLozinke = () => {
    const { t } = useTranslation();
    const auth = useContext(AuthContext);
    const toast = useRef(null);

    const [formData, setFormData] = useState(emptyForm);
    const [show, setShow] = useState({ currentPassword: false, newPassword: false, confirmPassword: false });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };
    const toggleShow = (field) => setShow(prev => ({ ...prev, [field]: !prev[field] }));

    const mismatch = formData.confirmPassword.length > 0 && formData.newPassword !== formData.confirmPassword;

    const submitChangePassword = () => {
        fetch(process.env.REACT_APP_BACKEND_URL + '/users/changePassword', {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
            body: JSON.stringify({ currentPassword: formData.currentPassword, newPassword: formData.newPassword }),
        })
            .then((response) => { if (response.ok) return response.json(); throw response; })
            .then((data) => {
                toast.current.show({ severity: 'success', summary: t('admin.m_uspesno'), detail: data.message, life: 3000 });
                setFormData(emptyForm);
            })
            .catch((error) => {
                if (error.json) error.json().then((m) => toast.current.show({ severity: 'error', summary: t('admin.m_greska'), detail: m.message, life: 3000 }));
                else toast.current.show({ severity: 'error', summary: t('admin.m_greska'), detail: t('admin.m_greska_na_serveru'), life: 3000 });
            });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!formData.currentPassword || !formData.newPassword || !formData.confirmPassword) {
            toast.current.show({ severity: 'warn', summary: t('admin.m_upozorenje'), detail: t('admin.m_popuni_sva_obavezna_polja'), life: 3000 });
            return;
        }
        if (formData.newPassword.length < 5) {
            toast.current.show({ severity: 'warn', summary: t('admin.m_upozorenje'), detail: t('admin.m_nova_lozinka_mora_imati_najmanje_5_karak'), life: 3000 });
            return;
        }
        if (formData.newPassword !== formData.confirmPassword) {
            toast.current.show({ severity: 'warn', summary: t('admin.m_upozorenje'), detail: t('admin.m_nova_lozinka_i_potvrda_lozinke_se_ne_pok'), life: 3000 });
            return;
        }
        confirmDialog({
            message: t('korisnik.potvrdaPromeneLozinke'),
            header: t('korisnik.promenaLozinke'),
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: t('common.da'),
            rejectLabel: t('common.ne'),
            accept: submitChangePassword,
        });
    };

    const fieldWrap = { display: 'flex', flexDirection: 'column', gap: '0.35rem' };
    const labelStyle = { fontWeight: 600, fontSize: '0.9rem' };

    // Jedno polje lozinke: input + eye dugme DESNO od inputa (1% razmaka).
    // NAPOMENA: render-funkcija (poziva se inline), NE zasebna komponenta — inače bi input gubio fokus.
    const renderPwField = (field, label, invalid) => (
        <div style={fieldWrap}>
            <label htmlFor={field} style={labelStyle}>{label}</label>
            <div className="pw-row">
                <InputText
                    id={field}
                    name={field}
                    type={show[field] ? 'text' : 'password'}
                    value={formData[field]}
                    onChange={handleChange}
                    placeholder={label}
                    className={invalid ? 'p-invalid' : ''}
                    style={{ flex: 1, minWidth: 0 }}
                />
                <button type="button" className="pw-eye-btn" onClick={() => toggleShow(field)}
                    aria-label={show[field] ? 'Sakrij lozinku' : 'Prikaži lozinku'}
                    title={show[field] ? 'Sakrij lozinku' : 'Prikaži lozinku'}>
                    <i className={`pi ${show[field] ? 'pi-eye-slash' : 'pi-eye'}`} />
                </button>
            </div>
        </div>
    );

    return (
        <div className="col-12">
            <Toast ref={toast} />
            <ConfirmDialog />
            <div style={{ maxWidth: 440, margin: '1.8rem auto 0', padding: '0 12px' }}>
                <Card>
                    <div style={{ textAlign: 'center', marginBottom: '1.4rem' }}>
                        <span style={{ display: 'inline-flex', width: 54, height: 54, borderRadius: '50%', background: 'rgba(37,99,235,0.12)', alignItems: 'center', justifyContent: 'center' }}>
                            <i className="pi pi-lock" style={{ fontSize: '1.6rem', color: '#2563eb' }} />
                        </span>
                        <h3 style={{ margin: '10px 0 2px', fontWeight: 700 }}>{t('korisnik.promenaLozinke')}</h3>
                        <p style={{ margin: 0, color: 'var(--text-muted, #888)', fontSize: '0.82rem' }}>{t('korisnik.lozinkaHelper')}</p>
                    </div>

                    <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1.1rem' }}>
                        {renderPwField('currentPassword', t('admin.trenutnaLozinka'))}
                        {renderPwField('newPassword', t('login.tabNovaLozinka'))}
                        <div>
                            {renderPwField('confirmPassword', t('admin.potvrdiNovuLoz'), mismatch)}
                            {mismatch && <small style={{ color: '#e53935' }}>{t('korisnik.lozinkeSeNePoklapaju')}</small>}
                        </div>

                        <Button type="submit" label={t('korisnik.promeniLozinku')} icon="pi pi-check"
                            className="p-button-success" style={{ marginTop: '0.4rem', width: '100%' }} />
                    </form>
                </Card>
            </div>
        </div>
    );
};

export default PromenaLozinke;
